import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Signature } from '../signature';

@Component({
    selector: 'kiene-qrcode-dialog',
    templateUrl: './qrcode-dialog.component.html',
    styleUrls: ['./qrcode-dialog.component.scss'],
})
export class QRCodeDialogComponent implements OnInit {
    signature: Signature;

    constructor(
        public dialogRef: MatDialogRef<QRCodeDialogComponent>,
        @Inject(MAT_DIALOG_DATA) data: any,
    ) {
        this.signature = data.signature;
    }

    ngOnInit() {}

    cancel() {
        this.dialogRef.close(null);
    }
}
